import {DateTime} from "luxon"
import {dataset, Attributes, Mui} from "@leap4/frontend";
import { IGraphTimePoint } from "@leap4/entities-discrepancy-common";

type SelectProps = Mui.SelectProps;


const {REVENUE, COST, PROFIT, IMPRESSIONS} = Attributes.NUMERIC.ALL

const selectProps: SelectProps = {size: "small"};


const graphMetrics = [
    {name: "Profit", value: PROFIT},
    {name: "Revenue", value: REVENUE},
    {name: "Cost", value: COST},
    {name: "Impressions", value: IMPRESSIONS}]

const graphMonths = [
    {name: "Januray", value: 0},
    {name: "Februray", value: 1},
    {name: "March", value: 2},
    {name: "April", value: 3},
    {name: "May", value: 4},
    {name: "June", value: 5},
    {name: "July", value: 6},
    {name: "August", value: 7},
    {name: "September", value: 8},
    {name: "October", value: 9},
    {name: "November", value: 10},
    {name: "December", value: 11},

]

const getOptionalComparesByViews = (graphViews) =>{
    const views = graphViews?.map(view =>{
        return graphMetrics.find(comp => {
            return comp.value === view
        })
    }) || []
    return views
}

const defaultMonthIdx = new Date().getMonth();


function getDaysInMonth(month = new Date().getMonth(), year = new Date().getFullYear()) {
    let date = new Date(year, month, 1);
    let days = [];
    while (date.getMonth() === month) {
        days.push(`${new Date(date).getDate()}`.padStart(2, '0'));
        date.setDate(date.getDate() + 1);
    }
    return days;
}

const currentDate = new Date().getDate();
const defaultLookback = currentDate < 3 ? 7 : currentDate-1;


function generateDataSets(dataTillNow: Array<IGraphTimePoint>, predictiveData, selectedMetric: string): dataset[] {
    const dataTillNowValues = dataTillNow.map((currData) => currData[selectedMetric])
    const predictiveValues = predictiveData.map((currData) => currData[selectedMetric])
    const tillNowDataset: dataset = {
        labelName: `${selectedMetric.toUpperCase()} Till Now`,
        values: dataTillNowValues,
        borderColor: 'rgba(235,62,50,1)',
        backgroundColor: 'rgba(255,102,50,0.7)',
    }

    const predictiveDataDataset: dataset = {
        labelName: `Predictive ${selectedMetric.toUpperCase()}`,
        values: dataTillNowValues.concat(predictiveValues),
        // values: dataTillNow.map(z=>undefined).concat(predictiveValues),
        // borderColor: 'rgba(235,62,50,1)',
        // backgroundColor: 'rgba(255,102,50,0.7)',
    }


    return [tillNowDataset, predictiveDataDataset];
}

export {
    selectProps,
    graphMetrics,
    graphMonths,
    defaultMonthIdx,
    getDaysInMonth,
    defaultLookback,
    REVENUE,
    generateDataSets,
    getOptionalComparesByViews
}